import RoleSelectionScreen from './screens/RoleSelectionScreen';

export default RoleSelectionScreen;
